import React from 'react';
import { formatCurrency } from '../../config';

const ComparePlantsView = ({ compareData }) => (
  <div className="space-y-6">
    <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
      <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">Plant Comparison - {compareData.date}</h3>
      <p className="text-sm text-gray-600">{compareData.plants_count} plants with data</p>
    </div>

    <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
      <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-4">Production & Cost Comparison</h3>
      <div className="overflow-x-auto -mx-4 sm:mx-0 px-4 sm:px-0">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Plant</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Production (MT)</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Despatches (MT)</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Total Cost</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Cost/MT</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {compareData.plants.map((plant, idx) => (
              <tr key={plant.plant_id} className={idx === 0 ? 'bg-green-50' : ''}>
                <td className="px-4 py-3">
                  <div className="font-medium">{plant.plant_name}</div>
                  <div className="text-xs text-gray-500">{plant.location}</div>
                </td>
                <td className="px-4 py-3 text-right font-semibold">{plant.production_mt}</td>
                <td className="px-4 py-3 text-right">{plant.despatches_mt}</td>
                <td className="px-4 py-3 text-right">{formatCurrency(plant.total_cost)}</td>
                <td className="px-4 py-3 text-right font-semibold text-[#156ACA]">{formatCurrency(plant.cost_per_mt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
      <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-4">Volume Efficiency Comparison (per MT)</h3>
      <div className="overflow-x-auto -mx-4 sm:mx-0 px-4 sm:px-0">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Plant</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Power (Units/MT)</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Steam (MT/MT)</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Water (KL/MT)</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Oil (L/MT)</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {compareData.plants.map(plant => (
              <tr key={plant.plant_id}>
                <td className="px-4 py-3 font-medium">{plant.plant_name}</td>
                <td className="px-4 py-3 text-right">{plant.volume_efficiency.power_units_per_mt}</td>
                <td className="px-4 py-3 text-right">{plant.volume_efficiency.steam_mt_per_mt}</td>
                <td className="px-4 py-3 text-right">{plant.volume_efficiency.water_kl_per_mt}</td>
                <td className="px-4 py-3 text-right">{plant.volume_efficiency.oil_l_per_mt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
      <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-4">Cost Breakdown Comparison</h3>
      <div className="overflow-x-auto -mx-4 sm:mx-0 px-4 sm:px-0">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Plant</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Power</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Steam</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Water</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Oil</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Maint.</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {compareData.plants.map(plant => (
              <tr key={plant.plant_id}>
                <td className="px-4 py-3 font-medium">{plant.plant_name}</td>
                <td className="px-4 py-3 text-right">{formatCurrency(plant.cost_breakdown.power)}</td>
                <td className="px-4 py-3 text-right">{formatCurrency(plant.cost_breakdown.steam)}</td>
                <td className="px-4 py-3 text-right">{formatCurrency(plant.cost_breakdown.water)}</td>
                <td className="px-4 py-3 text-right">{formatCurrency(plant.cost_breakdown.oil)}</td>
                <td className="px-4 py-3 text-right">{formatCurrency(plant.cost_breakdown.maintenance)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default ComparePlantsView;
